// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1hJbf","noInteraction":"EventWrapper_noInteraction__34PZd","pointerPassthrough":"EventWrapper_pointerPassthrough__1DYET"};